const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Waterford",

  webfeedDebuggerWebsiteUrl:
    "https://waterford.avid.com.au/masterplan/#/masterplan/",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
